import { render, staticRenderFns } from "./ProductsVisitedItem.vue?vue&type=template&id=49507baa&"
import script from "./ProductsVisitedItem.js?vue&type=script&lang=js&"
export * from "./ProductsVisitedItem.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports